import { StyleSheet } from 'react-native';
import React, { useEffect, useState } from 'react'
import i18n from 'utils/i18n'
import ThemedLayout from 'components/atoms/ThemedLayout'
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import LoadingComponent from 'components/atoms/Loading'
import { useRoute } from '@react-navigation/native'
import _ from 'lodash'
import QueryEmployeeBookingInvitationLogs from 'graphql/queries/QueryEmployeeBookingInvitationLogs'
import ListItemLog from 'scenes/home/invitation/_components/ListItemLog'
import ThemedList from 'components/atoms/ThemedList'
import ThemedBlock from 'components/atoms/ThemedBlock'
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'


const HomeInvitationLogs = () => {
	
	const route = useRoute();
	
	const [ logs, setLogs ] = useState( [] )
	const [ loading, setLoading ] = useState( true )
	
	const employeeBookingInvitationGuid = _.get( route.params, 'employee_booking_invitation_guid', null )
	
	const fetchLogs = () => {
		GraphqlGroupedBuilder.addQuery( 'booking_invite_logs', QueryEmployeeBookingInvitationLogs, {
			variables: {
				guid: employeeBookingInvitationGuid
			},
			resultPath: [ 'employee_booking_invitation', 'logs' ],
			callbackStart: setLoading.bind( this ,true ),
			callbackError: setLoading.bind( this ,false ),
			callbackSuccess: result => {
				setLogs( result )
				setLoading( false )
			}
		})
	}
	
	useEffect( () => {
		return fetchLogs();
	}, [] )
	
	let content = <LoadingComponent />
	if( !loading ) {
		content = (
			<ThemedBlock
				shadow>
				
				<ThemedList
					data={ logs }
					renderItem={ ListItemLog }
					style={ staticStyles.themedListPaddingHorizontal0 }
				/>
			</ThemedBlock>
		)
	}
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>
			
			<ThemedLayout
				title={ i18n.t('page.invitation.log.title') }
				topNavigation={ true }
				showBackButton={ true }>
				
				{ content }
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	)
}

const staticStyles = StyleSheet.create({
	themedListPaddingHorizontal0: {
		paddingHorizontal: 0,
	},
});

export default HomeInvitationLogs
